import Dialog from "@/types/Dialog.interface"

interface State {
    clientDeployedPopup: boolean
    dialogApp: Array<Dialog>
    dialogConfirm: Array<Dialog>
    dialogFeature: Array<Dialog>
    dialogMessage: Array<Dialog>
}

const defaults = () => {
    return {
        clientDeployedPopup: false,
        dialogApp: [],
        dialogConfirm: [],
        dialogFeature: [],
        dialogMessage: []
    }
}

export default {
    state: defaults(),
    mutations: {
        clientDeployedPopupSet(state: State, bool: boolean): void {
            state.clientDeployedPopup = bool
        },
        dialogAppSet (state: State, object: Dialog): void {
            state.dialogApp = state.dialogApp || []
            object.push ? state.dialogApp.push(object) : state.dialogApp.pop()
        },
        dialogConfirmSet (state: State, object: Dialog):void {
            state.dialogConfirm = state.dialogConfirm || []
            object.push ? state.dialogConfirm.push(object) : state.dialogConfirm.pop()
        },
        dialogFeatureSet (state: State, object: Dialog): void {
            state.dialogFeature = state.dialogFeature || []
            object.push ? state.dialogFeature.push(object) : state.dialogFeature.pop()
        },
        dialogMessageSet (state: State, object: Dialog): void {
            state.dialogMessage = state.dialogMessage || []
            object.push ? state.dialogMessage.push(object) : state.dialogMessage.pop()
        },
        dialogCloseAll(state: State, type: string): void {
            state[`dialog${type.toProperCase()}`] = []
        },
        dialogRemove(state: State, obj: Dialog): void {
            //  Create a selector for our dialog list name
            const listName = {
                APP: 'dialogApp',
                CONFIRM: 'dialogConfirm',
                FEATURE: 'dialogFeature',
                MESSAGE: 'dialogMessage'
            }[obj.type]

            //  Remove the dialog from the selected list, using uuid (which is required for this function to work)
            state[listName].remove(obj.uuid)
        }
    },
    actions: {
        dialogClose({commit}, type: string): boolean {
            let switchObj = {
                APP: 'dialogAppSet',
                CONFIRM: 'dialogConfirmSet',
                FEATURE: 'dialogFeatureSet',
                MESSAGE: 'dialogMessageSet'
            }
            commit(switchObj[type], { push: false, pop: true })
            return true
        },
        dialogOpen({commit}, dialog: Dialog): boolean {
            //  Capture properties needed to determine how to handle the dialog
            const type = dialog.type

            //  Set dialog to open
            dialog.isOpen = true
            dialog.push = true
            dialog.pop = false

            //  Pop the dialog
            const switchObj = {
                APP: 'dialogAppSet',
                CONFIRM: 'dialogConfirmSet',
                FEATURE: 'dialogFeatureSet',
                MESSAGE: 'dialogMessageSet'
            }
            commit(switchObj[type], dialog)
            return true
        },
        dialogPastDue({ commit }): void {
            //  Create a dialog payload
            const payload = {
                type: 'MESSAGE',
                title: "Subscription Past Due",
                text: "Your subscription is currently past due. Until you resolve any outstanding charges you will be prevented from sending messages.",
                icon: 'mdi-alert',
                color: 'yellow',
                isOpen: true,
                push: true,
                pop: false
            }

            //  Pop this dialog
            commit('dialogMessageSet', payload)
        }
    },
    getters: {
        clientDeployedPopup(state: State): boolean {
            return state.clientDeployedPopup
        },
        dialogApp(state: State): Array<Dialog> {
            return state.dialogApp
        },
        dialogConfirm(state: State): Array<Dialog> {
            return state.dialogConfirm
        },
        dialogFeature(state: State): Array<Dialog> {
            return state.dialogFeature
        },
        dialogMessage(state: State): Array<Dialog> {
            return state.dialogMessage
        }
    }
}
